module.exports = __webpack_public_path__ + "static/media/16GalleryPuppets.27b7cf09.jpeg";